<div class="flxClmn">
	<div class="page-title-container flxRow-between">
		<div class="flxClmn-center f-1-0">
			<div class="page-title-inner-container flxRow">
				<span class="page-title">Email Activity</span>
				<!--Information modal-->
				<more-info-c>
					<div class="flxClmn vSpace05" style="flex: 1 0;">
						<span style="font-weight: bold;">Actions</span>
						<br/>
						<span style="vertical-align: middle;"><b>Threat Analysis</b> - view the threat analysis for the email components (links/files/headers) and take actions on the email</span>
						<span style="vertical-align: middle;"><b>Show Content and Actions</b> - view the content of the quarantined email and take actions on it</span>
						<span style="vertical-align: middle;"><b>Release to mailbox</b> - release the email back to the recipient's inbox. Only do this if you know the email is safe</span>
						<span style="vertical-align: middle;"><b>Remove from mailbox</b> - remove the email from the recipient's mailbox. Note: removed emails can still be recovered using the "Release" action</span>
						<span style="vertical-align: middle;"><b>Set category</b> - manually change the category of the quarantined email</span>
						<span style="vertical-align: middle;"><b>Download as EML</b> - download the quarantined email (including attachments) as an EML file</span>
						<span style="vertical-align: middle;"><b>Preserve record</b> - select the email to be preserved and not be deleted by the default retention policy</span>
						<span style="vertical-align: middle;"><b>Delete record</b> - delete the record for the quarantined email on this page. The actual email will not be affected.</span>
					</div>
					<div class="flxClmn vSpace05" style="flex: 1 0;">
						<span style="font-weight: bold;">Status</span>
						<br/>
						<span style="vertical-align: middle;"><b style="color: darkorange;">Quarantined</b> - a potential threat has been found in the email. An admin can either remove or release a quarantined email</span>
						<span style="vertical-align: middle;"><b style="color: green;">Released</b> - an admin has found the email to be safe and released it back to the recipient's inbox</span>
						<span style="vertical-align: middle;"><b style="color: dimgray;">Pending release</b> - this email is being released to the recipient's mailbox</span>
						<span style="vertical-align: middle;"><b style="color: green;">Requested release</b> -  the recipient has requested to release this email from quarantine</span>
						<span style="vertical-align: middle;"><b style="color: red;">Removed</b> - an admin has found the email to be malicious and removed it completely</span>
					</div>
				</more-info-c>
			</div>
			<div class="page-subtitle-container">
				<span class="page-subtitle">Emails quarantined by Inbound Shield</span>
			</div>
		</div>
		<btn-c style="align-self: flex-end;"
			   *ngIf="mailboxInfo && isRecipientChangeNotifyTimeAllowed"
			   endIcon="far fa-bell" variant="outlined"
			   (action)="openNotifyOptionsPopup();">
			Quarantine Notifications
		</btn-c>
	</div>

	<div class="page-inner-content-holder no-scroll flxClmn">

		<trustifi-table-c
			class="trustifi-table quarantined-email-table" style="flex: 1 0; z-index: 5;"
			[list]="groupEmails"
			[headers]="[
				{text:'Received', sortKey:'created', width: '11%'},
				{text:'Sender', sortKey:'sender', width: '15%'},
				{text:'', width: '40px'},
				{text:'Subject', sortKey:'subject', width: '19%'},
				{text:'Mailbox', sortKey:'mailbox_email', width: '15%'},
				{text:'Status', sortKey:'status', width: '15%'},
				{text:'Category', sortKey:'category_priority', width: '10%'},
				{html:'tagsHeader', width: '19%'},
				{text:'', width: '25px'},
			]"
			[cellsPrototype]="[
				{html: 'createdCell'},
				{html: 'senderCell'},
				{html: 'hasLinkCell'},
				{textKey: 'subject'},
				{textKey: 'mailbox_email'},
				{html: 'statusCell'},
				{html: 'categoryCell'},
				{html: 'tagsCell'},
				{html: 'wasHandledCell'},
			]"
			(onAnyItemSelected)="!$event.isItemSelectCheckboxClicked && viewQuarantineInfo($event.item)"
			[bulkActions]="{
				enable: true,
				selectBulkActionCb:	selectMultipleEmailsAction,
				initBulkActionsFunction: showQuarantinedBulkActions
			}"
			[cellActions] = "{
				enable: true,
				selectItemActionCb:	selectAction,
				initActionsFunction: showQuarantinedActions
			}"
			(searchFunction)="searchFilterMailbox($event.searchTerm, $event.activeFilters)"
			[filterData]="filterData"
			[options]="{
				exportToCsvFunction: exportQuarantinedCsv,
				loadingTableFlag: getEmailsInProcess && !groupEmails.length,
				itemsNameSingular: 'email',
				refreshFunction: applyQuery,
				defaultSortKey: '-created',
				emptyStateMessage: 'Create a search query and click on <b>Get Emails</b> to show the results'
			}"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<!--action cells-->
				<div *ngIf="cellId === 'createdCell'">
					<div class="flxRow" style="align-items: center;">
					<span style="white-space: normal; text-overflow: unset; text-align: center; display: block; max-width: min-content;">
						{{item.created | date:'MM/dd/yyyy HH:mm'}}
					</span>
						<i class="far fa-lock" style="color: grey; padding-left: 5px;"
						   *ngIf="item.keep_forever"
						   tooltip="This email will not be deleted by the retention policy"></i>
					</div>
				</div>
				<!--hasLink cell cells-->
				<div *ngIf="cellId === 'hasLinkCell'">
					<div class="flxRow" style="align-items: center; justify-content: flex-end;">
						<i class="far fa-link mdc-text-grey" *ngIf="item?.links"
						   style="flex-grow: 0; min-width: 12px; font-size: 12px; text-align: center; opacity: .8;"
						   tooltip="{{item.links > 1 ? item.links + ' links' : '1 link'}}"></i>
						<i class="zmdi zmdi-attachment-alt mdc-text-grey" *ngIf="item?.attachments"
						   style="flex-grow: 0; min-width: 15px; font-size: 14px; text-align: center;"
						   tooltip="{{item.attachments > 1 ? item.attachments + ' attachments' : '1 attachment'}}"></i>
					</div>
				</div>
				<div *ngIf="cellId === 'senderCell'" class="flxRow">
					<div class="ellipsis" [ngStyle]="{'color': item.sender ? 'black' : '#808080'}">
						<!--cTooltip start-->
						<div contentTooltip>
							<ng-template #contentToolTipTemplate>
								<div class="vSpace3">
									<div class="hSpace1"
										 [ngStyle]="{'color': item.sender ? 'black' : '#808080'}"
										 style="font-size: 11px; display: flex;">
										<b style="flex-shrink: 0; ">From</b>:&nbsp;
										<span class="ellipsis"
											  tooltip="{{item.sender}}">{{item.sender}}</span>&nbsp;
										<a (ngInit)="item.senderExtendEmailIsClicked = false"
										   (click)="copyItemToClipboard(item.sender); item.senderExtendEmailIsClicked = true; $event.stopPropagation();"
										   [ngStyle]="item.senderExtendEmailIsClicked && {'color':'darkgreen'}"
										   [ngClass]="item.senderExtendEmailIsClicked && 'animated flash'">
											<i class="far fa-copy" tooltip="Copy Email"></i>
										</a>
									</div>
									<div *ngIf="item?.malicious?.tpResults && item?.malicious?.tpResults?.resHead?.from?.returnPath"
										 class="hSpace1"
										 [ngStyle]="{'color': item.sender ? 'black' : '#808080'}"
										 style="font-size: 11px; display: flex;">
										<b style="flex-shrink: 0; ">Return-Path</b>:&nbsp;
										<span class="ellipsis"
											  tooltip="{{item.malicious.tpResults.resHead.from.returnPath}}">{{item.malicious.tpResults.resHead.from.returnPath}}</span>&nbsp;
										<a (ngInit)="item.senderExtendReturnPathIsClicked = false"
										   (click)="copyItemToClipboard(item.malicious.tpResults.resHead.from.returnPath); item.senderExtendReturnPathIsClicked = true; $event.stopPropagation();"
										   [ngStyle]="item.senderExtendReturnPathIsClicked && {'color':'darkgreen'}"
										   [ngClass]="item.senderExtendReturnPathIsClicked && 'animated flash'">
											<i class="far fa-copy" tooltip="Copy Return-Path"></i>
										</a>
									</div>
									<div class="hSpace1"
										 [ngStyle]="{'color': item.sender ? 'black' : '#808080'}"
										 style="font-size: 11px; display: flex;">
										<b style="flex-shrink: 0; ">Message-ID</b>:&nbsp;
										<span style="direction: rtl;" class="ellipsis"
											  tooltip="{{item.message_id}}"
											  placement="bottom">{{item.message_id}}</span>&nbsp;
										<a (ngInit)="item.senderExtendMessageIdIsClicked = false"
										   (click)="copyItemToClipboard(item.message_id); item.senderExtendMessageIdIsClicked = true; $event.stopPropagation();"
										   [ngStyle]="item.senderExtendMessageIdIsClicked && {'color':'darkgreen'}"
										   [ngClass]="item.senderExtendMessageIdIsClicked && 'animated flash'">
											<i class="far fa-copy" tooltip="Copy Message-ID"></i>
										</a>
									</div>
								</div>
							</ng-template>
						</div>
						<!--cTooltip end-->
						<i class="far fa-question-circle" style="margin-right:5px;"
						   *ngIf="item.auth_sender && item.auth_sender.status"
						   [ngStyle]="{'color': item.auth_sender.status === 'request' ? 'grey' : item.auth_sender.status === 'approve' ? 'green' : 'red'}"
						   placement="bottom"
						   tooltip="Sender has {{item.auth_sender.status === 'request' ? 'not yet responded to' : item.auth_sender.status === 'approve' ? 'approved': 'denied'}} the authentication request"></i>
						<span>{{item.sender}}</span>
					</div>
				</div>

				<div *ngIf="cellId === 'statusCell'">
					<div style="color: black;" class="flxRow hSpace05"
						 [ngStyle]="{'color': item.status === dic.CONSTANTS.quarantinedActions.quarantine.value && 'var(--ui-warning)' || item.status === dic.CONSTANTS.quarantinedActions.release.value && 'var(--ui-success)' || item.status === dic.CONSTANTS.quarantinedActions.remove.value && 'var(--ui-danger)' || item.status === dic.CONSTANTS.quarantinedActions.pending.value && 'var(--ui-text-muted)' || item.status === dic.CONSTANTS.quarantinedActions.releaseFailure.value && 'var(--ui-danger)'}">
						<span style="text-transform: capitalize;">{{item.status === dic.CONSTANTS.quarantinedActions.release.value ? 'released' : item.status === dic.CONSTANTS.quarantinedActions.remove.value ? 'removed' : item.status === dic.CONSTANTS.quarantinedActions.pending.value ? 'Pending release' : item.status === dic.CONSTANTS.quarantinedActions.releaseFailure.value ? 'Pending release' : item.status}}</span>
					</div>
					<!--CC: reason as a muted second line (same as Email Activity admin table)-->
					<div class="text-muted ellipsis" style="font-size: 11.5px; line-height: 1.3;" *ngIf="item.reason" tooltip="{{item.reason}}">
						{{item.reason}}
					</div>
				</div>

				<div *ngIf="cellId === 'categoryCell'" class="flxRow hSpace05" style="align-items: center;">
					<!--CC: category chip (same look as the threat tags)-->
					<div class="flxRow threat-tag not-clickable m-0" style="align-items: center;" [ngClass]="item.color">
						<div class="threat-tag-BG"></div>
						<span class="threat-tag-text">{{item.category}}</span>
					</div>
					<i *ngIf="item.diffCategory" class="far fa-exclamation-circle"
					   tooltip="Category is different for some recipients"></i>
				</div>

				<div *ngIf="cellId === 'wasHandledCell'">
					<div *ngIf="item.reviewed_completed" class="d-flex centralize" >
						<i class="far fa-check" style="color: green; padding-right: 4px;" tooltip="Email was handled by a reviewer"></i>
					</div>
				</div>

				<div *ngIf="cellId === 'tagsCell'">
					<div class="flxRow" style=" align-items: center; flex-wrap: wrap;" *ngIf="item.threatTags && item.threatTags.length">
						<div class="flxRow threat-tag hvr-opacity hSpace05" style="align-items: center;"
							 *ngFor="let tag of item.threatTags"
							 [ngClass]="tag.colorObj.color"
							 [ngStyle]="{'color' : tag.colorObj.color}"
							 (click)="$event.stopPropagation(); setTagAsFilter(tag.name)">
							<div class="threat-tag-BG"></div>
							<i class="far threat-tag-icon" [ngClass]="tag.colorObj.icon"></i>
							<span class="threat-tag-text" [style.font-size.px]="tag.name?.length > 18 ? 10.5 : 12">{{tag.name}}</span>
						</div>
					</div>
				</div>

				<div *ngIf="cellId === 'tagsHeader'">
					<div class="flxRow w100" style=" align-items: center; width: 100%;">
						<span style="flex-shrink: 0;">Metrics</span>
						<a class="flxRow" style="color: royalblue; font-weight: 400; padding: 5px 10px; flex: 1 0; align-items: center;"
						   *ngIf="activeTagAsFilter"
						   (click)="setTagAsFilter('')">
						<span class="hvr-underline" style="white-space: normal; text-align: center; font-size: calc(0.7rem + 0.05vw);">
							{{activeTagAsFilter}}
						</span>
							<i class="far fa-times" style="white-space: normal; padding: 5px;"></i>
						</a>
					</div>
				</div>
			</ng-template>

			<div tableButtons>
				<div class="w100 flxRow-between" style="z-index: 10;">
					<div class="flxRow" style="flex-wrap: wrap-reverse; margin-bottom: 1px;">
						<!--query-->
						<div class="flxRow" (ngInit)="showQueryModal = false;" (clickOutside)="showQueryModal = false;" style="align-items: flex-end;">
							<div class="flxRow" style="flex: 1 0; border: solid 1px var(--ui-border-strong); border-radius: var(--ui-radius-sm); overflow: visible; position: relative; min-width: 460px; height: 32px;"
								 [ngStyle]="{'border-color' : isQueryError ? 'red' : 'var(--ui-border-strong)'}">
								<div class="flxRow hSpace05" style="align-items: center; padding: 10px; border-right: solid 1px var(--ui-border-strong); cursor: pointer; border-radius: var(--ui-radius-sm) 0 0 var(--ui-radius-sm);"
									 (click)="showQueryModal = !showQueryModal"
									 [ngStyle]="{'background' : showQueryModal ? '#f7f7f7' : 'white'}">
									<svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" style="width: 22px; height: 22px; vertical-align: middle; fill: currentColor; overflow: hidden;" viewBox="0 0 1024 1024" version="1.1"><path d="M881.4 250.9H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h739.9c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM272.1 454H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5S296 454 272.1 454zM272.1 657.1H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h130.6c23.9 0 43.5 19.6 43.5 43.5s-19.6 43.5-43.5 43.5zM853.8 847.5L715.3 709c-16.9-16.9-16.9-44.6 0-61.5s44.6-16.9 61.5 0L915.3 786c16.9 16.9 16.9 44.6 0 61.5s-44.6 16.9-61.5 0zM467.9 860.2H141.5c-23.9 0-43.5-19.6-43.5-43.5s19.6-43.5 43.5-43.5h326.4c23.9 0 43.5 19.6 43.5 43.5 0.1 23.9-19.5 43.5-43.5 43.5z"/><path d="M619.4 290.5C493.3 290.5 391 392.8 391 519s102.3 228.5 228.5 228.5S847.9 645.2 847.9 519 745.6 290.5 619.4 290.5z m0 388.4c-88.3 0-159.9-71.6-159.9-159.9 0-88.3 71.6-159.9 159.9-159.9s160 71.5 160 159.9c0 88.3-71.6 159.9-160 159.9z"/></svg>
									<i class="far fa-chevron-down" style="font-size: smaller;"></i>
								</div>

								<div class="flxRow hSpace1 animated fadeIn hvr-shadow" style="flex: 1 0; align-items: center; padding: 0 10px; cursor: pointer;"
									 (click)="showQueryModal = !showQueryModal">
									<a class="diamond-indent" style="font-weight: bold; height: auto; position: relative; padding-left: 12px; text-transform: capitalize;"
									   *ngFor="let query of quarantinedQueryDisplay"
									   tooltip="{{query.tooltip}}">
										{{query.title}}
									</a>
								</div>

								<!--query modal-->
								<div class="" style="position: absolute; bottom: -3px; transform: translateY(100%); line-height: 15px; left: 0; background: white; border: solid 1px var(--ui-border); border-radius: var(--ui-radius-md); box-shadow: var(--ui-shadow-lg); min-width: 537px;"
									 *ngIf="showQueryModal">
									<div class="flxClmn vSpace2" style="padding: 20px;">
										<div class="flxRow hSpace2">
											<label class="radio-container" style="display: block; width: fit-content; height: 30px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
												<input type="radio" name="normalQuery" [value]="queryTypes.normal"
													   [(ngModel)]="queryType"
													   [checked]="queryType === queryTypes.normal"
													   (ngModelChange)="queryValidationErrors = [];">
												<span class="checkmark"></span>
											</label>
											<div class="flxClmn vSpace2" style="padding-left: 15px; flex: 1 0;"
												 [ngStyle]="queryType === queryTypes.messageIdOnly ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}"
												 (click)="queryType = queryTypes.normal">
												<div class="flxRow hSpace3">
													<span style="font-weight: bold; flex-basis: 85px; margin-top: 5px;">Date:</span>
													<div class="flxClmn" style="margin-left: 0; flex: 1 0;">
														<app-dropdown-c class="capitalize-box w100" style="z-index: 50; height: 27px; min-height: 27px; flex: 1 0; max-width: 280px;"
																		[ngStyle]="{'margin-bottom' : resultsPeriod.value === dic.CONSTANTS.trendsPeriod.range.value ? '10px' : '0'}"
																		text="{{resultsPeriod.display}}">
															<li *ngFor="let item of searchPeriod"
																(click)="changePeriod(item)">
																{{item.display}}
															</li>
														</app-dropdown-c>
														<div *ngIf="resultsPeriod.value === dic.CONSTANTS.trendsPeriod.range.value"
															 class="flxRow" style="position: relative; align-items: center; margin-top: -4px; margin-left: 6px;">
															<div class="flex-row hSpace1" style="width: 340px;">
																<div class="flxRow hSpace05 f-1-0" style="align-items: center;">
																	<span>Date Range:</span>
																	<date-picker-c class="f-1-0" style="max-width: 220px;"
																				   [(dateModel)]="range"
																				   [isRange]="true"
																				   [dateFormat]="'mm/dd/yyyy'">
																	</date-picker-c>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="flxRow hSpace3" style="align-items: center; z-index: 4; position: relative;">
													<span style="font-weight: bold; flex-basis: 85px;">Category:</span>
													<app-dropdown-c style="z-index: 50; height: 27px; min-height: 27px; flex: 1 0; max-width: 280px; margin: 0;"
																	[error]="queryValidationErrors?.includes('category')"
																	text="{{quarantinedQuery.category && _.keys(_.pickBy(quarantinedQuery.category)).join(', ') || 'Select'}}">
														<li *ngFor="let category of quarantinedQuery.category | keyvalue: gs.returnZero"
															(click)="quarantinedQuery.category[category.key] = !quarantinedQuery.category[category.key]; $event.stopPropagation();"
															id="{{'queryCategories-' + category.key}}">
															<checkbox (click)="$event.preventDefault();"
																	  [model]="quarantinedQuery.category[category.key]">
																{{category.key}}
															</checkbox>
														</li>
													</app-dropdown-c>
													<span style="position: absolute; bottom: -1px; right: calc(20% + 7px); transform: translateY(15px); font-size: 12px; color: red;"
														  *ngIf="queryValidationErrors?.includes('category')">
													select at least 1
												</span>
												</div>
												<div class="flxRow hSpace3" style="align-items: center; z-index: 3; position: relative;">
													<span style="font-weight: bold; flex-basis: 85px;">Sub Category:</span>
													<app-dropdown-c style="z-index: 50; height: 27px; min-height: 27px; flex: 1 0; max-width: 280px; margin: 0;"
																	text="{{quarantinedQuery.sub_category && _.keys(_.pickBy(quarantinedQuery.sub_category)).join(', ') || '(Optional)'}}">
														<ul style="overflow: auto; max-height: 180px;">
															<li *ngFor="let status of quarantinedQuery.sub_category | keyvalue: gs.returnZero"
																(click)="quarantinedQuery.sub_category[status.key] = !quarantinedQuery.sub_category[status.key]; $event.stopPropagation();"
																id="{{'queryCategories-' + status.key}}">
																<checkbox (click)="$event.preventDefault();" [model]="quarantinedQuery.sub_category[status.key]">
																	{{status.key}}
																</checkbox>
															</li>
														</ul>
													</app-dropdown-c>
												</div>
												<div class="flxRow hSpace3" style="align-items: center; z-index: 2; position: relative;">
													<span style="font-weight: bold; flex-basis: 85px;">Status:</span>
													<app-dropdown-c style="z-index: 50; height: 27px; min-height: 27px; flex: 1 0; max-width: 280px; margin: 0;"
																	text="{{quarantinedQuery.status && _.keys(_.pickBy(quarantinedQuery.status)).join(', ') || '(Optional)'}}">
														<li *ngFor="let status of quarantinedQuery.status | keyvalue : gs.returnZero"
															(click)="quarantinedQuery.status[status.key] = !quarantinedQuery.status[status.key]; $event.stopPropagation();"
															id="{{'queryStatus-' + status.key}}">
															<checkbox (click)="$event.preventDefault();"
																	  [model]="quarantinedQuery.status[status.key]">
																{{status.key}}
															</checkbox>
														</li>
													</app-dropdown-c>
												</div>
												<div class="flxRow hSpace3" style="align-items: center; position: relative;">
													<span style="font-weight: bold; flex-basis: 85px;">Sender:</span>
													<input type="text" style="margin: 0; flex: 1 0; max-width: 280px; height: 27px;"
														   (keyup.enter)="applyQuery();"
														   placeholder="Sender's email/domain/ip"
														   [ngClass]="{'validation-error' : queryValidationErrors?.includes('sender')}"
														   [(ngModel)]="quarantinedQuery.sender">
													<span style="position: absolute; bottom: -1px; right: calc(20% + 7px); transform: translateY(15px); font-size: 12px; color: red;"
														  *ngIf="queryValidationErrors?.includes('sender')">
													Invalid email
													</span>
												</div>
												<div class="flxRow hSpace3" style="align-items: center; position: relative;">
													<span style="font-weight: bold; flex-basis: 85px;">Subject:</span>
													<input type="text" style="margin: 0; flex: 1 0; max-width: 280px; height: 27px;"
														   (keyup.enter)="applyQuery();"
														   placeholder="Email's subject (exact or partial)"
														   [(ngModel)]="quarantinedQuery.subject">
												</div>
												<div class="flxRow hSpace3" style="align-items: center; position: relative;">
													<span style="font-weight: bold; flex-basis: 85px;">Link:</span>
													<input type="text" style="margin: 0; flex: 1 0; max-width: 293px; height: 27px;"
														   (keyup.enter)="applyQuery();"
														   placeholder="Link in email body (exact or partial)"
														   [(ngModel)]="quarantinedQuery.link">
												</div>
												<div class="flxRow hSpace3" style="align-items: center; position: relative;">
													<span style="font-weight: bold; flex-basis: 85px;">File:</span>
													<input type="text" style="margin: 0; flex: 1 0; max-width: 293px; height: 27px;"
														   (keyup.enter)="applyQuery();"
														   placeholder="File name/hash"
														   [(ngModel)]="quarantinedQuery.file">
												</div>
											</div>
										</div>

										<div class="flxRow hSpace2" style="align-items: flex-start;">
											<label class="radio-container" style="display: block; width: fit-content; height: 30px; margin: 0; padding: 0; transform: scale(0.85); margin-top: 4px;">
												<input type="radio" name="byIdQuery" [value]="queryTypes.messageIdOnly"
													   [(ngModel)]="queryType"
													   [checked]="queryType === queryTypes.messageIdOnly"
													   (ngModelChange)="queryValidationErrors = [];">
												<span class="checkmark"></span>
											</label>
											<div class="flxRow hSpace3" style="align-items: center; padding-left: 15px; flex: 1 0; position: relative;"
												 [ngStyle]="queryType === queryTypes.normal ? {'opacity' : '0.5', 'cursor' : 'pointer'} : {'opacity' : '1' , 'cursor' : 'default'}"
												 (click)="queryType = queryTypes.messageIdOnly">
												<span style="font-weight: bold; flex-basis: 85px;">Message ID:</span>
												<input type="text" style="margin: 0; flex: 1 0; max-width: 280px; height: 27px;"
													   (keyup.enter)="applyQuery();"
													   placeholder="Exact message ID"
													   [ngClass]="{'validation-error' : queryValidationErrors?.includes('message_id')}"
													   [(ngModel)]="quarantinedQuery.message_id">
												<span style="position: absolute; bottom: -1px; right: calc(20% + 7px); transform: translateY(15px); font-size: 12px; color: red;"
													  *ngIf="queryValidationErrors?.includes('message_id')">
												required field
											</span>
											</div>
										</div>

										<div class="flxRow" style="align-items: center; justify-content: flex-end;">
											<div class="flxRow" style="gap: 8px;">
												<btn-c variant="text" style="height: 32px;"
													   btnTooltip="Reset all query fields" (action)="resetQuery();">
													Reset
												</btn-c>
												<btn-c style="height: 32px;"
													   id="getQueryEmailsBtnInner"
													   [loading]="getEmailsInProcess"
													   (action)="applyQuery()">
													Get Emails
												</btn-c>
											</div>
										</div>

									</div>
								</div>
							</div>

							<btn-c class="connected-to-left" style="align-self: flex-end; height: 32px; margin-left: -6px; z-index: 3;"
								   [loading]="getEmailsInProcess"
								   (action)="applyQuery();">
								Get Emails
							</btn-c>
						</div>
					</div>
				</div>
			</div>
		</trustifi-table-c>

	</div>

	<!--Threat Analysis popup-->
	<popup-c *ngIf="emailInfoPopup?.show" class="threat-protection-popup no-content-padding" size="fullscreen">
		<div class="h100 w100 flxClmn" style="overflow: hidden;" tabindex="0" [appAutoFocus]="true" focusDelay="20" (keydown.escape)="closeQuarantinedPopup();">
			<!--Popup header-->
			<div class="flxClmn-around tp-popup-header" style="flex: 1 0; max-height: 120px; padding: 10px 20px; border-bottom: solid 1px lightgrey; z-index: 100; background: linear-gradient(90deg, white,white 58%, #e9e9e9ad), url('images/popup-header-bg.png'); background-size: auto; background-repeat: round;">
				<div class="flxRow-between">
					<div class="flxRow ellipsis hSpace2" style="align-items: center; padding-right: 5%;">
						<img src="images/favicon/favicon-32x32.png" style="width: 20px; margin: 0; image-rendering: -webkit-optimize-contrast;">
						<h3 class="ellipsis">{{curEmail.subject}}</h3>
					</div>
					<div class="flxRow">
						<a (click)="closeQuarantinedPopup();">
							<i class="far fa-times" style="font-size: 1.3rem; padding: 10px;"></i>
						</a>
					</div>
				</div>

				<div class="flxRow hSpace2" style="align-items: center;">
					<!--quarantinedCategories: ['Malicious', 'Suspicious', 'Spam', 'Graymail', 'External', 'Safe'],-->
					<div class="flxRow-center hSpace1" style="border-radius: 250px; align-items: center; font-weight: 500; background: transparent; border: solid 2px; padding: 4px 15px; margin-left: 30px;"
						 [ngStyle]="{'border-color': setInboundStatusStyles(curEmail.category).color}">
						<i class="far" [ngStyle]="{'color' : setInboundStatusStyles(curEmail.category).color}"
						   [ngClass]="curEmail.category === 'Safe' ? 'fa-check' : curEmail.category === 'External' ? 'fa-external-link-alt' : (curEmail.category === 'Spam' || curEmail.category === 'Graymail') ? 'fa-exclamation-circle' : 'fas fa-biohazard'">
						</i>
						<span style="font-size: 0.9rem; font-weight: bold;"
							  [ngStyle]="{'color' : setInboundStatusStyles(curEmail.category).color}">
                                    {{curEmail.category}}
                                </span>
					</div>
					<div class="vertical-separator" style="border-width: 2px; margin: 0 1.5vw; border-color: darkgrey; border-left: none;"></div>
					<div class="flxRow hSpace1" style="align-items: center;">
						<span style="font-size: 1rem; color: dimgrey;">
							This email is
							<b [ngStyle]="{'color': curEmail?.status === dic.CONSTANTS.quarantinedActions.quarantine.value && 'darkorange' || curEmail.status === dic.CONSTANTS.quarantinedActions.release.value && 'darkgreen' || curEmail.status === dic.CONSTANTS.quarantinedActions.remove.value && 'darkred' || curEmail.status === dic.CONSTANTS.quarantinedActions.pending.value && 'dimgray' || curEmail.status === dic.CONSTANTS.quarantinedActions.releaseFailure.value && 'red'}">
								{{curEmail.status === dic.CONSTANTS.quarantinedActions.release.value ? 'released' : curEmail.status === dic.CONSTANTS.quarantinedActions.remove.value ? 'removed' : curEmail.status === dic.CONSTANTS.quarantinedActions.pending.value ? 'Pending release' : curEmail.status === dic.CONSTANTS.quarantinedActions.releaseFailure.value ? 'quarantined' : curEmail.status}}
							</b>
						</span>
						<span *ngIf="curEmail.reason">
							<i style="font-weight: 400;" class="far fa-question-circle"
							   tooltip="{{curEmail.reason}}">
							</i>
						</span>
					</div>
					<div class="vertical-separator" style="border-width: 2px; margin: 0 1.5vw; border-color: darkgrey; border-left: none;"></div>
					<div class="flxRow hSpace1" style="font-size: 1rem; align-items: center;">
						<span style="color: dimgrey;">Mailbox:</span>
						<app-dropdown-c style="width: 320px; height: 36px; --bs-dropdown-max-height: 320px; --bs-dropdown-overflow: auto;"
										[enableSearch]="true"
										[items]="curEmail.emails"
										[itemDisplayKey]="mailbox_email"
										(onItemClicked)="changeRecipientThreats($event.item)"
										*ngIf="curEmail.parent && curEmail.emails.length > 1"
										text="{{curEmail.curRecipient.mailbox_email}}"></app-dropdown-c>
						<input type="text" readonly style="width: 320px; height: 36px; margin: 0; font-size: 14px; cursor: default;"
							   onclick="return false"
							   *ngIf="!curEmail.parent || curEmail.emails.length === 1"
							   [value]="curEmail.mailbox_email?.toString()" />
					</div>
					<div class="vertical-separator" style="border-width: 2px; margin: 0 1.5vw; border-color: darkgrey; border-left: none;"></div>
					<div class="flxRow hSpace1" style="align-items: center;">
						<i class="far fa-clock" style="font-size: 1rem; color: dimgrey;"></i>
						<span class="ellipsis" style="font-size: 1rem; color: dimgrey;">{{moment(curEmail.created).format('dddd, MMMM Do YYYY, h:mm A')}} ({{moment(curEmail.created).fromNow()}})</span>
					</div>
				</div>
			</div>

			<div class="flxRow" style="flex: 8 0; overflow: auto;">
				<!--Sidebar-->
				<div class="flxClmn tp-popup-sidebar" style="box-shadow: 0 0 5px grey; background: linear-gradient(45deg, #d9efff75, white); position: sticky; left: 0; top: 0; z-index: 50;">
					<div class="flxClmn" style="padding: max(1.2vw,15px); flex: 2 0;">
						<!--Analysis Summary-->
						<div class="flxClmn vSpace1">
							<div class="flxRow-between" style="margin-bottom: min(15px,1vh);">
								<div class="flxClmn w100 vSpace05">
									<span style="font-family: 'Roboto Condensed', sans-serif; font-size: 1.1rem;">Summary</span>
									<div style="background: linear-gradient(90deg, #9b9b9b, transparent); width: 100%; height: 1px;"></div>
								</div>
							</div>
							<div class="flxRow hSpace1" style="align-items: center;"
								 *ngIf="curTPResults?.resHead?.message"
								 [ngStyle]="{'color': setInboundStatusStyles(curTPResults.headerStatus).color}">
								<i class="far fa-user" style="color: inherit; font-size: 0.9rem; flex-basis: 15px;"></i>
								<div class="flxClmn vSpace05">
                                    <span style="color: initial;">
										{{curTPResults.resHead.message}}
										<i *ngIf="curTPResults.resHead.sub_status_description"
										   style="font-weight: 400;margin-left: 3px;" class="far fa-question-circle"
										   tooltip="{{curTPResults.resHead.sub_status_description}}"
										   placement="right"></i>
									</span>
									<span *ngIf="curTPResults.resHead.from && curTPResults.resHead.from.highlight" [innerHTML]="curTPResults.resHead.from.highlight"></span>
								</div>
							</div>
							<div class="flxRow hSpace1" style="align-items: center;"
								 *ngIf="curTPResults?.resUrl?.message"
								 [ngStyle]="{'color': setInboundStatusStyles(curTPResults.urlStatus).color}">
								<i class="far fa-link" style="color: inherit; font-size: 0.9rem; flex-basis: 15px;"></i>
								<div class="flxClmn vSpace05">
                                            <span style="color: initial;">
												{{curTPResults.resUrl.message}}
												<i *ngIf="curTPResults.resUrl.sub_status_description"
												   style="font-weight: 400;margin-left: 3px;" class="far fa-question-circle"
												   tooltip="{{curTPResults.resUrl.sub_status_description}}"
												   placement="right"></i>
											</span>
									<span *ngIf="curTPResults.resUrl.highlight" [innerHTML]="curTPResults.resUrl.highlight"></span>
								</div>
							</div>
							<div class="flxRow hSpace1" style="align-items: center;"
								 *ngIf="curTPResults?.resHash?.message"
								 [ngStyle]="{'color': setInboundStatusStyles(curTPResults.hashStatus).color}">
								<i class="far fa-file" style="color: inherit; font-size: 0.9rem; flex-basis: 15px;"></i>
								<div class="flxClmn vSpace05">
                                            <span style="color: initial;">
												{{curTPResults.resHash.message}}
												<i *ngIf="curTPResults.resHash.sub_status_description"
												   style="font-weight: 400;margin-left: 3px;" class="far fa-question-circle"
												   tooltip="{{curTPResults.resHash.sub_status_description}}"
												   placement="right"></i>
											</span>
									<span *ngIf="curTPResults.resHash.highlight" [innerHTML]="curTPResults.resHash.highlight"></span>
								</div>
							</div>
						</div>
						<!--Classification-->
						<!--<div class="flxClmn vSpace1">
							<div class="flxClmn vSpace1">
								<span style="font-family: 'Roboto Condensed', sans-serif; font-size: 1.1rem;">Classification</span>
								<div style="background: linear-gradient(90deg, #9b9b9b, transparent); width: 100%; height: 1px;"></div>
							</div>
							<div class="flxRow" style="flex-wrap: wrap; align-items: center; /*height: 80px;*/ overflow: auto; padding: 10px 5px;">
								<div ng-repeat="classification in curEmail.classifications"
									 class="flxRow hSpace1" style="background: rgba(255,0,0,0.02); margin: 5px; border: solid 2px red; border-radius: 3px; padding: 5px;">
								</div>
								<div class="flxRow hSpace05" style="background: rgba(255,0,0,0.02); margin: 5px; border: solid 2px red; border-radius: 3px; padding: 3px 10px; align-items: center;">
									<i class="fas fa-biohazard" style="color: #ff4e3e"></i>
									<span style="color: #ff4e3e">Spoofing</span>
								</div>
								<div class="flxRow hSpace05" style="background: rgba(255,0,0,0.02); margin: 5px; border: solid 2px red; border-radius: 3px; padding: 3px 10px; align-items: center;">
									<i class="fas fa-biohazard" style="color: #ff4e3e"></i>
									<span style="color: #ff4e3e">Spoofing</span>
								</div>
								<div class="flxRow hSpace05" style="background: rgba(255,0,0,0.02); margin: 5px; border: solid 2px red; border-radius: 3px; padding: 3px 10px; align-items: center;">
									<i class="fas fa-biohazard" style="color: #ff4e3e"></i>
									<span style="color: #ff4e3e">Spoofing</span>
								</div>
							</div>
							<span class="large-sc-only">Email category: <b>{{curEmail.category}}</b></span>
							<span class="large-sc-only">
								Is category wrong?&nbsp;
								<a class="blueLink" style="text-decoration: underline;" (click)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.setCategory.display)">
									Change category
								</a>
							</span>
						</div>-->
						<!-- <div class="flxClmn" style="margin-top: 3vh;">
							 <span style="text-decoration: underline;">Tags</span>
							 <div class="flxRow" style="flex-wrap: wrap; align-items: center; overflow: auto; padding: 10px 5px;">
								 <div ng-repeat="classification in curEmail.classifications"
									  class="flxRow hSpace1" style="background: rgba(255,0,0,0.02); margin: 5px; border: solid 2px red; border-radius: 3px; padding: 5px;">
								 </div>
								 <div class="flxRow hSpace05" style="background: rgba(255,0,0,0.02); margin: 5px; border: solid 2px red; border-radius: 3px; padding: 3px 10px; align-items: center;">
									 <i class="fas fa-biohazard" style="color: #ff4e3e"></i>
									 <span style="color: #ff4e3e">Spoofing</span>
								 </div>
								 <div class="flxRow hSpace05" style="background: rgba(255,0,0,0.02); margin: 5px; border: solid 2px red; border-radius: 3px; padding: 3px 10px; align-items: center;">
									 <i class="fas fa-biohazard" style="color: #ff4e3e"></i>
									 <span style="color: #ff4e3e">Spoofing</span>
								 </div>
							 </div>
						 </div>-->
					</div>
					<hr style="margin: 0;" *ngIf="curTPResults"/>
					<!--Actions-->
					<div class="flxClmn-between" style="flex: 4 0;">
						<div class="flxClmn animated fadeIn" style="padding: max(1.2vw,15px);" *ngIf="curTPResults">
							<div class="flxClmn">
								<div class="flxClmn w100 vSpace05">
									<span style="font-family: 'Roboto Condensed', sans-serif; font-size: 1.1rem;">Email Actions</span>
									<div style="background: linear-gradient(90deg, #9b9b9b, transparent); width: 100%; height: 1px; margin-bottom: min(15px,1vh);"></div>
								</div>
								<!--email actions-->
								<div class="flxRow animated fadeIn" style="flex-wrap: wrap;">
									<btn-c class="quarantined-popup-action-btn f-1-0"
										   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.remove.value) >= 0"
										   btnTooltip="The email will be removed completely from the recipient's mailbox." tooltip-direction="right"
										   [isDisabled]="loadQuarantineData"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.remove.display);">
										Remove
									</btn-c>
									<btn-c class="quarantined-popup-action-btn f-1-0"
										   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.release.value) >= 0"
										   btnTooltip="The email will be released to the recipient's inbox." tooltip-direction="right"
										   [isDisabled]="loadQuarantineData"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.release.display);">
										Release
									</btn-c>
									<btn-c class="quarantined-popup-action-btn f-1-0"
										   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.requestRelease.value) >= 0"
										   btnTooltip="Send a request to release this email from quarantine." tooltip-direction="right"
										   [isDisabled]="loadQuarantineData"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.requestRelease.display);">
										Request Release
									</btn-c>
									<btn-c class="quarantined-popup-action-btn f-1-0"
										   *ngIf="curEmail.methods.indexOf(dic.CONSTANTS.quarantinedActions.linksWhitelist.value) >= 0"
										   btnTooltip="All non-safe links contained in this email will now be considered safe." tooltip-direction="right"
										   [isDisabled]="loadQuarantineData"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.linksWhitelist.display);">
										Allowlist Links
									</btn-c>
									<btn-c class="quarantined-popup-action-btn f-1-0"
										   btnTooltip="Change the category of this email to safe, external, spam, graymail, suspicious, or malicious." tooltip-direction="right"
										   [isDisabled]="loadQuarantineData"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.setCategory.display);">
										Set Category
									</btn-c>
									<btn-c class="quarantined-popup-action-btn f-1-0"
										   btnTooltip="This email will be marked as {{curEmail.reviewed_completed ?  'not ' : ''}}handled by a reviewer" tooltip-direction="right"
										   [isDisabled]="loadQuarantineData"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.handled.display)">
										{{curEmail.reviewed_completed ? 'Set not handled' : 'Set handled'}}
									</btn-c>
								</div>
							</div>

							<div class="flxClmn" style="margin-top: 3vh;">
								<div class="flxClmn w100 vSpace05">
									<span style="font-family: 'Roboto Condensed', sans-serif; font-size: 1.1rem;">Sender Actions</span>
									<div style="background: linear-gradient(90deg, #9b9b9b, transparent); width: 100%; height: 1px; margin-bottom: min(15px,1vh);"></div>
								</div>
								<!--sender actions-->
								<div class="flxRow animated fadeIn" style="flex-wrap: wrap;">
									<btn-c class="quarantined-popup-action-btn f-1-0"
										   *ngIf="curEmail.senderMethods.indexOf(dic.CONSTANTS.quarantinedActions.whitelist.value) >= 0"
										   btnTooltip="Emails from this sender will be released and arrive to the recipient's inbox." tooltip-direction="right"
										   [isDisabled]="loadQuarantineData"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.whitelist.display)">
										Allowlist
									</btn-c>
									<btn-c class="quarantined-popup-action-btn f-1-0"
										   *ngIf="curEmail.senderMethods.indexOf(dic.CONSTANTS.quarantinedActions.blacklist.value) >= 0"
										   btnTooltip="Emails from this sender will be removed completely from the recipient mailbox." tooltip-direction="right"
										   [isDisabled]="loadQuarantineData"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.blacklist.display)">
										Blocklist
									</btn-c>
									<btn-c class="quarantined-popup-action-btn f-1-0"
										   btnTooltip="Ask the sender to confirm their identity." tooltip-direction="right"
										   [isDisabled]="loadQuarantineData"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.authSender.display)">
										Authenticate
									</btn-c>
								</div>
							</div>
						</div>
						<div class="flxClmn-center" style="padding: 0 4% 2vh; align-items: center; min-height: 45px;">
							<div class="loading-spinner" style="position: relative; left: unset; top: unset;" *ngIf="loadQuarantineData && !curEmail.loadingEmailContent"></div>
							<span [ngStyle]="{'color': popupError.error.type === 'info' ? 'darkgreen':'#e84634'}" style="text-align: center; padding: 3%; border-radius: 5px; background: white;"
								  *ngIf="(popupError && popupError.error && popupError.error.message || '') && !loadQuarantineData">
                                        {{popupError && popupError.error && popupError.error.message || ' '}}
                                    </span>
						</div>
					</div>
				</div>
				<div class="flxClmn" style="flex: 1 0;">
					<div class="threat-protection-grid h100" style="flex: 1 0; overflow: auto; padding: 0 0.75vw;">
						<!--Message Analysis Data Card-->
						<div class="threat-protection-card flxClmn ro18 co7 md-co12" style="min-height: 755px; max-height: 75vh;"
							 [ngClass]="{'co12' : !allowReviewerShowContent}">
							<div class="card-header flxRow-between" style="align-items: center;">
                                        <span class="card-title"
											  [ngStyle]="{'color' : setInboundStatusStyles(curTPResults?.resHead?.status).color === 'darkred' ? 'darkred' : ''}">
                                            Message Analysis
                                        </span>
								<div class="flxRow hSpace1">
									<i class="far hvr-opacity animated fadeIn" style="font-size: 1rem;" *ngIf="curTPResults && curTPResults.resHead && (!curTPResults.resHead.sub_status || !curTPResults?.resHead?.sub_status?.length || curTPResults?.resHead?.status === dic.CONSTANTS.threatProtection.status.safe)"
									   [ngClass]="setInboundStatusStyles(curTPResults?.resHead?.status).icon === 'fa-bug' ? 'fa-times-circle' : setInboundStatusStyles(curTPResults?.headerStatus).icon"
									   [ngStyle]="{'color' : setInboundStatusStyles(curTPResults.resHead.status).color}"
									   tooltip="{{curTPResults?.resHead?.message || 'Some headers were found malicious or suspicious'}}"></i>
									<div class="flxRow hSpace05" style="background: white; width: fit-content; border: solid 2px; border-radius: 3px; padding: 2px 7px; align-items: center;"
										 *ngIf="curTPResults && curTPResults?.resHead && curTPResults?.resHead?.sub_status && curTPResults?.resHead?.sub_status?.length && curTPResults?.resHead?.status !== dic.CONSTANTS.threatProtection.status.safe"
										 [ngStyle]="{'border-color': setInboundStatusStyles(curTPResults?.resHead?.status).color,
                                                                                    'color': setInboundStatusStyles(curTPResults.resHead.status).color}">
										<i class="fa" style="color: inherit; font-size: 11px;" [ngClass]="setInboundStatusStyles(curTPResults.resHead.status).icon"></i>
										<span style="color: inherit; font-size: 12px;">{{curTPResults?.resHead?.sub_status}}</span>
									</div>
									<i class="far fa-spinner fa-spin animated fadeIn" style="opacity: 0.4; font-size: 1rem; animation-duration: 1s;" *ngIf="!curTPResults"></i>
								</div>
							</div>
							<div class="flxClmn animated fadeIn" style="flex: 1 0; overflow: auto;" *ngIf="curTPResults">
								<div class="flxClmn vSpace05" style="padding: 15px 10px;">
									<div class="flxRow">
										<span style="text-decoration: underline;">Sender Identities</span>
										<span style="margin-left: auto; color: blue; cursor: pointer;" (click)="viewEmailFromSender(curEmail)">View other emails from this sender</span>
									</div>
									<table class="simpleDataTable w100 message-analysis-table middle" style="table-layout: fixed;">
										<tr>
											<th style="width: 100px; padding: 0;"></th>
											<th style="padding: 0;"></th>
											<th style="width: 30px; padding: 0;"></th>
										</tr>
										<tr *ngIf="curTPResults?.resHead?.from?.senderMail && curTPResults?.resHead?.from?.senderMail !== curTPResults?.resHead?.from?.senderMailFrom">
											<td>
												<span><b>Appears As</b></span>
											</td>
											<td colspan="2">
												<span style="padding: 0; white-space: pre-wrap; word-break: break-word;">{{curTPResults.resHead.from.senderMail}}</span>
											</td>
										</tr>
										<tr *ngIf="curTPResults?.resHead?.from?.senderMailFrom">
											<td>
												<span><b>Sender</b></span>
											</td>
											<td colspan="2">
												<span style="padding: 0; white-space: pre-wrap; word-break: break-word;">{{curTPResults.resHead.from.senderMailFrom}}</span>
											</td>
										</tr>
										<tr *ngIf="curTPResults?.resHead && curTPResults?.resHead?.relationshipLevel">
											<td><b>Relationship</b></td>
											<td>
												<div class="flxRow hSpace1">
													<div style="flex: 1 0; background-color: #f1f1f1; border: 1px solid #ccc; border-radius: 5px;">
														<div class="widthAnimation" style="border-radius: 3px; text-align: center; word-break: keep-all; height: 100%;"
															 [ngStyle]="{ 'width': (curTPResults.resHead.relationshipLevel && curTPResults.resHead.relationshipLevel.total ? (curTPResults.resHead.relationshipLevel.total * 0.95 + 5)  : 5) + '%', 'background-color': curTPResults.resHead.relationshipLevel && curTPResults.resHead.relationshipLevel.total >= 70 ? 'darkgreen' : curTPResults.resHead.relationshipLevel && curTPResults.resHead.relationshipLevel.total >= 50 ? 'darkorange' : 'darkred'}"></div>
													</div>
													<span>{{curTPResults.resHead.relationshipLevel && curTPResults.resHead.relationshipLevel.total || 0}}%</span>
												</div>
											</td>
											<td>
												<i style="font-weight: 400;" class="far fa-question-circle checkmark" tooltip="Sender's relationship level with the user and organisation.<br/>This score is calculated at the time the email was received and does not reflect changes that were made after that time."></i>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.from.replyTo">
											<td>
												<span><b>Reply To</b></span>
											</td>
											<td colspan="2">
												<span style="padding: 0; white-space: pre-wrap; word-break: break-word;">{{curTPResults.resHead.from.replyTo}}</span>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.from.returnPath">
											<td>
												<span><b>Return Path</b></span>
											</td>
											<td colspan="2">
												<span style="padding: 0; white-space: pre-wrap; word-break: break-word;">{{curTPResults.resHead.from.returnPath}}</span>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.from.messageID">
											<td>
												<span><b>Message ID</b></span>
											</td>
											<td colspan="2">
												<span style="word-break: break-all;">{{curTPResults.resHead.from.messageID}}</span>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.from.sendingMTA.domain">
											<td>
												<span><b>MTA Domain</b></span>
											</td>
											<td colspan="2">
												<div class="mta-connecting-host-cell">
													<span class="mta-connecting-hostname">{{curTPResults.resHead.from.sendingMTAFull || curTPResults.resHead.from.sendingMTA.domain}}</span>
													<span class="mta-domain-ip-value" *ngIf="curTPResults.resHead.from.sendingMTAIP">{{curTPResults.resHead.from.sendingMTAIP}}</span>
												</div>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.from.ipAddresses && curTPResults.resHead.from.ipAddresses.length">
											<td>
												<span><b>IP Addresses</b></span>
											</td>
											<td colspan="2">
												<span class="mta-ip-addresses-list">
													<ng-container *ngFor="let ip of threatAnalysisIpAddressesMtaFirst(curTPResults.resHead.from); let i = index">
														<span *ngIf="i > 0" class="mta-ip-addresses-sep" aria-hidden="true">,</span>
														<ng-container *ngIf="ipMatchesThreatAnalysisSendingMta(curTPResults.resHead.from, ip)">
															<span class="mta-address-ip-with-tag">
																<span class="mta-address-ip-text">{{ip}}</span>
																<span class="mta-address-tag">MTA</span>
															</span>
														</ng-container>
														<span *ngIf="!ipMatchesThreatAnalysisSendingMta(curTPResults.resHead.from, ip)">{{ip}}</span>
													</ng-container>
												</span>
											</td>
										</tr>
									</table>
								</div>
								<div class="flxClmn vSpace05" style="padding: 15px 10px;">
									<span style="text-decoration: underline;">AI Confidence</span>
									<table class="simpleDataTable w100 message-analysis-table middle" style="table-layout: fixed;">
										<tr>
											<th style="width: 100px; padding: 0;"></th>
											<th style="padding: 0;"></th>
											<th style="width: 30px; padding: 0;"></th>
										</tr>
										<tr>
											<td>
												<span><b>AI Decision</b></span>
											</td>
											<td>
                                                        <span style="text-transform: capitalize;"
															  *ngIf="!curTPResults.resHead.AIresults.skip">
                                                           {{!curTPResults.resHead.AIresults.decision ? 'Safe' : curTPResults.resHead.AIresults.decision === 'threat' ? 'Business Email Compromise (BEC)' : curTPResults.resHead.AIresults.decision}}
                                                       </span>
												<span style="text-transform: capitalize;" *ngIf="curTPResults.resHead.AIresults.skip">
                                                           {{curTPResults.resHead.AIresults.decision ? curTPResults.resHead.AIresults.decision : 'Internal metrics decision'}}
                                                       </span>
											</td>
											<td>
												<i style="font-weight: 400;" class="far fa-question-circle checkmark" tooltip="The final AI decision for this email, based on the AI score for BEC, Spam, and Graymail.<br/> The final email status may differ from the AI decision, due to link and attachment analysis."></i>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.AIresults">
											<td>
												<span><b>- BEC AI</b></span>
											</td>
											<td>
												<div class="flxRow hSpace1" (ngInit)="threat_body_conf_precentages = curTPResults.resHead.AIresults.threat_body_conf ? curTPResults.resHead.AIresults.threat_body_conf > 1 ? 100 : (curTPResults.resHead.AIresults.threat_body_conf * 100) : 0">
													<div style="flex: 1 0; background-color: #f1f1f1; border: 1px solid #ccc; border-radius: 5px;">
														<div class="widthAnimation" style="border-radius: 3px; text-align: center; word-break: keep-all; height: 100%;"
															 [ngStyle]="{ 'width': threat_body_conf_precentages + '%', 'background-color' : threat_body_conf_precentages <= 50 ? 'darkgreen' : threat_body_conf_precentages <= 70 ? 'darkorange' : 'darkred'}"></div>
													</div>
													<span style="flex-basis: 32px;">{{threat_body_conf_precentages | number: 0}}%</span>
												</div>
											</td>
											<td>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.AIresults">
											<td>
												<span><b>- Spam AI</b></span>
											</td>
											<td>
												<div class="flxRow hSpace1" (ngInit)="spam_body_conf_precentages = curTPResults.resHead.AIresults.spam_body_conf ? curTPResults.resHead.AIresults.spam_body_conf > 1 ? 100 : (curTPResults.resHead.AIresults.spam_body_conf * 100) : 0">
													<div style="flex: 1 0; background-color: #f1f1f1; border: 1px solid #ccc; border-radius: 5px;">
														<div class="widthAnimation" style="border-radius: 3px; text-align: center; word-break: keep-all; height: 100%;"
															 [ngStyle]="{ 'width': spam_body_conf_precentages + '%', 'background-color' : spam_body_conf_precentages <= 50 ? 'darkgreen' : spam_body_conf_precentages <= 70 ? 'darkorange' : 'darkred'}"></div>
													</div>
													<span style="flex-basis: 32px;">{{spam_body_conf_precentages | number: 0}}%</span>
												</div>
											</td>
											<td>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.AIresults">
											<td>
												<span><b>- Graymail AI</b></span>
											</td>
											<td>
												<div class="flxRow hSpace1" (ngInit)="graymail_body_conf_precentages = curTPResults.resHead.AIresults.graymail_body_conf ? curTPResults.resHead.AIresults.graymail_body_conf > 1 ? 100 : (curTPResults.resHead.AIresults.graymail_body_conf * 100) : 0">
													<div style="flex: 1 0; background-color: #f1f1f1; border: 1px solid #ccc; border-radius: 5px;">
														<div class="widthAnimation" style="border-radius: 3px; text-align: center; word-break: keep-all; height: 100%;"
															 [ngStyle]="{ 'width': graymail_body_conf_precentages + '%', 'background-color' : graymail_body_conf_precentages <= 50 ? 'darkgreen' : graymail_body_conf_precentages <= 70 ? 'darkorange' : 'darkred'}"></div>
													</div>
													<span style="flex-basis: 32px;">{{graymail_body_conf_precentages | number: 0}}%</span>
												</div>
											</td>
											<td>
											</td>
										</tr>
									</table>
								</div>
								<div class="flxClmn vSpace05" style="padding: 15px 10px;">
									<span style="text-decoration: underline;">Authentication Standards</span>
									<table class="simpleDataTable w100 message-analysis-table middle" style="table-layout: fixed;">
										<tr>
											<th style="width: 100px; padding: 0;"></th>
											<th style="padding: 0;"></th>
											<th style="width: 30px; padding: 0;"></th>
										</tr>
										<tr *ngIf="curTPResults.resHead.spf">
											<td>
												<span><b>SPF</b></span>
											</td>
											<td>
												<span class="ellipsis" style="padding: 0;">{{curTPResults.resHead.spf.message ? curTPResults.resHead.spf.message : (curTPResults.resHead.from.isInternal ? 'SPF is Internal' : 'No SPF was sent.')}}</span>
											</td>
											<td>
												<i *ngIf="!curTPResults.resHead.spf.message" class="far" [ngClass]="curTPResults.resHead.from.isInternal ? 'fa-check' : 'fa-exclamation-circle'"></i>
												<i class="far" *ngIf="curTPResults.resHead.spf.message" [ngClass]="curTPResults.resHead.spf.score === 2 ? 'fa-exclamation-circle' : curTPResults.resHead.spf.score > 1 ? 'fa-check' : 'fa-times-circle'"></i>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.arc">
											<td>
												<span><b>ARC</b></span>
											</td>
											<td>
												<span class="ellipsis" style="padding: 0;">{{curTPResults.resHead.arc.message ? curTPResults.resHead.arc.message : (curTPResults.resHead.from.isInternal ? 'ARC is Internal' : 'No ARC was sent.')}}</span>
											</td>
											<td>
												<i *ngIf="!curTPResults.resHead.arc.message" class="far" [ngClass]="curTPResults.resHead.from.isInternal ? 'fa-check' : 'fa-exclamation-circle'"></i>
												<i class="far" *ngIf="curTPResults.resHead.arc.message" [ngClass]="curTPResults.resHead.arc.score === 2 ? 'fa-exclamation-circle' : curTPResults.resHead.arc.score > 1 ? 'fa-check' : 'fa-times-circle'"></i>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.dkim">
											<td><b>DKIM</b></td>
											<td>
												<span class="ellipsis" style="padding: 0;">{{curTPResults.resHead.dkim.message ? curTPResults.resHead.dkim.message : (curTPResults.resHead.from.isInternal ? 'DKIM is Internal' : 'No DKIM was sent')}}</span>
											</td>
											<td>
												<i *ngIf="!curTPResults.resHead.dkim.message" class="far" [ngClass]="curTPResults.resHead.from.isInternal ? 'fa-check' : 'fa-exclamation-circle'"></i>
												<i class="far" *ngIf="curTPResults.resHead.dkim.message" [ngClass]="curTPResults.resHead.dkim.score === 2 ? 'fa-exclamation-circle' : curTPResults.resHead.dkim.score > 1 ? 'fa-check' : 'fa-times-circle'"></i>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.dmarc">
											<td><b>DMARC</b></td>
											<td>
												<span class="ellipsis" style="padding: 0;">{{curTPResults.resHead.dmarc.message ? curTPResults.resHead.dmarc.message : (curTPResults.resHead.from.isInternal ? 'DMARC is Internal' : 'No DMARC was sent.')}}</span>
											</td>
											<td>
												<i *ngIf="!curTPResults.resHead.dmarc.message" class="far" [ngClass]="curTPResults.resHead.from.isInternal ? 'fa-check' : 'fa-exclamation-circle'"></i>
												<i class="far" *ngIf="curTPResults.resHead.dmarc.message" [ngClass]="curTPResults.resHead.dmarc.score === 2 ? 'fa-exclamation-circle' : curTPResults.resHead.dmarc.score > 1 ? 'fa-check' : 'fa-times-circle'"></i>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.compauth">
											<td><b>CompAuth</b></td>
											<td>
												<span class="ellipsis" style="padding: 0;">{{curTPResults.resHead.compauth.message ? curTPResults.resHead.compauth.message : (curTPResults.resHead.from.isInternal ? 'CompAuth is Internal' : 'No CompAuth was sent.')}}</span>
											</td>
											<td>
												<i *ngIf="!curTPResults.resHead.compauth.message" class="far" [ngClass]="curTPResults.resHead.from.isInternal ? 'fa-check' : 'fa-exclamation-circle'"></i>
												<i class="far" *ngIf="curTPResults.resHead.compauth.message" [ngClass]="curTPResults.resHead.compauth.score === 2 ? 'fa-exclamation-circle' : curTPResults.resHead.compauth.score > 1 ? 'fa-check' : 'fa-times-circle'"></i>
											</td>
										</tr>
										<tr *ngIf="curTPResults.resHead.from && curTPResults.resHead.from.tls && (curTPResults.resHead.from.tls.message || curTPResults.resHead.from.tls.recipient.message || curTPResults.resHead.from.tls.external.message || curTPResults.resHead.from.tls.sender.message)">
											<td>
												<span><b>TLS</b></span>
											</td>
											<td>
												<div class="flxClmn vSpace05">
													<span>{{curTPResults.resHead.from.tls.message}}</span>
													<span *ngIf="curTPResults.resHead.from.tls.recipient.message">{{curTPResults.resHead.from.tls.recipient.message}}</span>
													<span *ngIf="curTPResults.resHead.from.tls.external.message">{{curTPResults.resHead.from.tls.external.message}}</span>
													<span *ngIf="curTPResults.resHead.from.tls.sender.message">{{curTPResults.resHead.from.tls.sender.message}}</span>
												</div>
											</td>
											<td>
												<div class="flxClmn" style="align-items: flex-start;">
													<i class="far" [ngClass]="curTPResults.resHead.from.tls.status === false ? 'fa-times-circle' : 'fa-check'"></i>
												</div>
											</td>
										</tr>
									</table>
								</div>
							</div>
							<div class="flxClmn-center" style="align-items: center; flex: 1 0;" *ngIf="!curTPResults">
								<span style="opacity: 0.5;">Loading</span>
							</div>
						</div>
						<div class="flxClmn ro18 co7 md-co12" style="min-height: 755px;"
							 [ngClass]="{'co12' : !allowReviewerShowContent}">
							<div class="threat-protection-card flxClmn" style="flex: 1 0;">
								<div class="card-header flxRow-between" style="align-items: center;">
                                            <span class="card-title" [ngStyle]="{'color' : setInboundStatusStyles(curTPResults?.urlStatus).color === 'darkred' ? 'darkred' : ''}">
                                                Links Analysis {{curTPResults?.resUrl?.list?.length ? '(' + curTPResults?.resUrl?.list?.length + ')' : ''}}
                                            </span>
									<div class="flxRow hSpace1">
										<i class="far hvr-opacity" style="font-size: 1rem;" *ngIf="curTPResults && curTPResults?.resUrl && (!curTPResults?.resUrl?.sub_status || !curTPResults?.resUrl?.sub_status?.length || curTPResults?.resUrl?.status === dic.CONSTANTS.threatProtection.status.safe)"
										   tooltip="{{curTPResults.urlStatus}}"
										   [ngClass]="setInboundStatusStyles(curTPResults?.urlStatus).icon === 'fa-bug' ? 'fa-times-circle' : setInboundStatusStyles(curTPResults?.urlStatus).icon"
										   [ngStyle]="{'color' : setInboundStatusStyles(curTPResults?.urlStatus).color}">
										</i>
										<div class="flxRow hSpace05" style="background: white; width: fit-content; border: solid 2px; border-radius: 3px; padding: 2px 7px; align-items: center;"
											 *ngIf="curTPResults && curTPResults?.resUrl && curTPResults?.resUrl.sub_status && curTPResults?.resUrl?.sub_status.length && curTPResults?.resUrl.status !== dic.CONSTANTS.threatProtection.status.safe"
											 [ngStyle]="{'border-color': setInboundStatusStyles(curTPResults?.resUrl.status).color,
                                                                                    'color': setInboundStatusStyles(curTPResults?.resUrl?.status).color}">
											<i class="fa" style="color: inherit; font-size: 11px;" [ngClass]="setInboundStatusStyles(curTPResults?.resUrl?.status).icon"></i>
											<span style="color: inherit; font-size: 12px;">{{curTPResults?.resUrl?.sub_status}}</span>
										</div>
										<i class="far fa-spinner fa-spin animated fadeIn" style="opacity: 0.4; font-size: 1rem; animation-duration: 1s;" *ngIf="!curTPResults"></i>
									</div>
								</div>
								<div class="flxClmn animated fadeIn" style="align-items: center; flex: 1 0; padding: 10px; overflow: auto;"
									 *ngIf="curTPResults"
									 [ngStyle]="{'justify-content' : !curTPResults.resUrl.list || !curTPResults.resUrl.list.length ? 'center' : ''}">
									<div class="w100" style="flex: 1 0;" *ngIf="curTPResults.resUrl.list && curTPResults.resUrl.list.length">
										<table class="simpleDataTable w100 message-analysis-table middle" style="table-layout: fixed;">
											<tr>
												<th style="padding: 0;"></th>
											</tr>
											<tr *ngFor="let url of curTPResults.resUrl.list">
												<td>
													<div class="flxClmn vSpace1 ellipsis" style="padding: 10px 0;">
														<div class="flxRow" style="align-items: center;">
															<div style="flex: 1 0; padding-right: 15px;" class="ellipsis flxRow hSpace05">
																<b style="flex-basis: 40px;">Name:</b>
																<span class="ellipsis" style="flex: 1 0;">{{url.name ? url.name : url.domain ? url.domain : url.url}}</span>
															</div>
															<div class="flxRow" style="align-items: center;" (ngInit)="url.icon = setInboundStatusStyles(url.status).icon;">
																<i class="far" *ngIf="!url.category" [ngClass]="url.icon === 'fa-check-circle' ? 'fa-check' : url.icon === 'fa-bug' ? 'fa-times-circle' : url.icon"
																   [ngStyle]="{'color': setInboundStatusStyles(url.status).color}" placement="right" tooltip="{{url.status}}"></i>
																<div class="flxRow hSpace05" style="background: white; width: fit-content; border: solid 2px; border-radius: 3px; padding: 2px 7px; align-items: center;"
																	 *ngIf="url.category"
																	 [ngStyle]="{'border-color': setInboundStatusStyles(url.status).color,
                                                                                    'color': setInboundStatusStyles(url.status).color}">
																	<i class="fa" style="color: inherit; font-size: 10px;" [ngClass]="setInboundStatusStyles(url.status).icon"></i>
																	<span style="color: inherit; font-size: 11px;">{{url.category}}</span>
																</div>
															</div>
														</div>
														<div class="flxRow" style="align-items: flex-end;" *ngIf="url?.original_url || url.url">
															<div class="flxRow hSpace05 ellipsis" style="padding-right: 45px; font-weight: 300; flex: 1 0;">
																<b style="flex-basis: 40px;">URL:</b>
																<span class="ellipsis" style="flex: 1 0;" tooltip="{{url.original_url || url.url}}">{{url.original_url || url.url}}</span>
															</div>
															<a (click)="previewLink(url.redirect_url || url.original_url || url.url)" style="text-align: right; padding-right: 3px;">
																<i class="fas fa-eye" style="opacity: 0.7;" tooltip="Safe Preview"></i>
															</a>
															<a (click)="copyItemToClipboard(url.original_url || url.url);" style="text-align: right;">
																<i class="far fa-copy" style="opacity: 0.7;" tooltip="Copy full URL"></i>
															</a>
														</div>
														<div class="flxRow" style="align-items: flex-end;" *ngIf="url?.url && url?.redirect_url && (url?.original_url && url?.original_url !== url?.redirect_url || !url?.original_url && url?.url !== url?.redirect_url)">
															<div class="flxRow hSpace05 ellipsis" style="padding-right: 45px; font-weight: 300; flex: 1 0;">
																<b style="flex-basis: 40px;">Redirect:</b>
																<span class="ellipsis" style="flex: 1 0;" tooltip="{{url.redirect_url || url.url}}">{{url.redirect_url || url.url}}</span>
															</div>
															<a (click)="copyItemToClipboard(url.redirect_url || url.url);" style="text-align: right;">
																<i class="far fa-copy" style="opacity: 0.7;" tooltip="Copy full redirect URL"></i>
															</a>
														</div>
														<div class="flxRow" style="align-items: flex-end;" *ngIf="url.malware_type">
															<div class="flxRow hSpace05 ellipsis" style="padding-right: 45px; font-weight: 300; flex: 1 0;">
																<b style="flex-basis: 40px;">Malware Type:</b>
																<span class="ellipsis" style="flex: 1 0;">{{url.malware_type}}</span>
															</div>
															<a (click)="copyItemToClipboard(url.malware_type);" style="text-align: right;">
																<i class="far fa-copy" style="opacity: 0.7;" tooltip="Copy malware type"></i>
															</a>
														</div>
														<div class="flxRow" style="align-items: flex-end;" *ngIf="url?.domain_age">
															<div class="flxRow hSpace05 ellipsis" style="padding-right: 45px; font-weight: 300; flex: 1 0;">
																<b style="flex-basis: 40px;">Domain Age:</b>
																<span class="ellipsis" style="flex: 1 0;">{{url.domain_age | date:'MM/dd/yyyy'}}</span>
															</div>
														</div>
														<div class="flxRow" style="align-items: flex-end;" *ngIf="isUrlTrackingEnabled">
															<div class="flxRow hSpace05 ellipsis" style="padding-right: 45px; font-weight: 300; flex: 1 0;">
																<b style="flex-basis: 40px;">Tracking:</b>
																<a class="blue-link" style="flex: 1 0; text-decoration: underline; font-weight: 400;" *ngIf="url?.clickInfo?.devices && url?.clickInfo?.devices?.length"
																   (click)="openClickTrackingPopup(url)">
																	{{'Clicked ' + url.clickInfo.devices.length + ' time' + (url.clickInfo.devices.length > 1 ? 's' : '')}}
																</a>
																<span *ngIf="!url?.clickInfo?.devices || url?.clickInfo?.devices?.length === 0">
                                                                    Was not clicked yet
                                                                </span>
															</div>
														</div>
													</div>
												</td>
											</tr>
										</table>
									</div>
									<span *ngIf="!curTPResults.resUrl.list || !curTPResults.resUrl.list.length">No links in email</span>
								</div>
								<div class="flxClmn-center" style="align-items: center; flex: 1 0;" *ngIf="!curTPResults">
									<span style="opacity: 0.5;">Loading</span>
								</div>
							</div>
							<div class="threat-protection-card flxClmn" style="flex: 1 0;">
								<div class="card-header flxRow-between" style="align-items: center;">
                                            <span class="card-title" [ngStyle]="{'color' : setInboundStatusStyles(curTPResults?.hashStatus).color === 'darkred' ? 'darkred' : ''}">
                                                Attachments Analysis {{curTPResults?.resHash && curTPResults?.resHash?.list && curTPResults?.resHash?.list?.length ? '(' + curTPResults?.resHash?.list?.length + ')' : ''}}
                                            </span>
									<div class="flxRow hSpace1">
										<i class="far hvr-opacity" style="font-size: 1rem;" *ngIf="curTPResults && curTPResults?.resHash && (!curTPResults?.resHash?.sub_status || !curTPResults?.resHash?.sub_status?.length || curTPResults?.resHash?.status === dic.CONSTANTS.threatProtection.status.safe)"
										   tooltip="{{curTPResults.hashStatus}}"
										   [ngClass]="setInboundStatusStyles(curTPResults?.hashStatus).icon === 'fa-bug' ? 'fa-times-circle' : setInboundStatusStyles(curTPResults?.hashStatus).icon"
										   [ngStyle]="{'color' : setInboundStatusStyles(curTPResults?.hashStatus).color}">
										</i>
										<div class="flxRow hSpace05" style="background: white; width: fit-content; border: solid 2px; border-radius: 3px; padding: 2px 7px; align-items: center;"
											 *ngIf="curTPResults && curTPResults?.resHash && curTPResults?.resHash?.sub_status && curTPResults?.resHash?.sub_status?.length && curTPResults?.resHash?.status !== dic.CONSTANTS.threatProtection.status.safe"
											 [ngStyle]="{'border-color': setInboundStatusStyles(curTPResults?.resHash?.status).color,
                                                                'color': setInboundStatusStyles(curTPResults?.resHash?.status).color}">
											<i class="fa" style="color: inherit; font-size: 11px;" [ngClass]="setInboundStatusStyles(curTPResults?.resHash?.status).icon"></i>
											<span style="color: inherit; font-size: 12px;">{{curTPResults?.resHash?.sub_status}}</span>
										</div>
										<i class="far fa-spinner fa-spin animated fadeIn" style="opacity: 0.4; font-size: 1rem; animation-duration: 1s;" *ngIf="!curTPResults"></i>
									</div>
								</div>
								<div class="flxClmn animated fadeIn" style="align-items: center; flex: 1 0; padding: 10px; overflow: auto;"
									 *ngIf="curTPResults"
									 [ngStyle]="{'justify-content' : !curTPResults.resHash.list || !curTPResults.resHash.list.length ? 'center' : ''}">
									<div style="flex: 1 0;" *ngIf="curTPResults.resHash.list && curTPResults.resHash.list.length">
										<table class="w100 simpleDataTable message-analysis-table middle" style="table-layout: fixed;">
											<tr>
												<th style="padding: 0;"></th>
											</tr>
											<tr *ngFor="let file of curTPResults.resHash.list">
												<td>
													<div class="flxClmn vSpace1" style="padding: 10px 0;">
														<div class="flxRow" style="align-items: center;">
															<span style="font-weight: 500; flex: 1 0; padding-right: 15px; word-break: break-all;">
																{{file.name}}
															</span>
															<div class="flxRow hSpace05" style="align-items: center;" (ngInit)="file.icon = setInboundStatusStyles(file.status).icon;">
																<a (click)="previewAttachmentFromEmail(curEmail, file)" style="text-align: right;" *ngIf="allowReviewerShowContent">
																	<i class="fas fa-eye" style="opacity: 0.7;" tooltip="Preview"></i>
																</a>
																<i class="far" *ngIf="!file.category" [ngClass]="file.icon === 'fa-check-circle' ? 'fa-check' : file.icon === 'fa-bug' ? 'fa-times-circle' : file.icon"
																   [ngStyle]="{'color': setInboundStatusStyles(file.status).color}" placement="right" tooltip="{{file.status}}"></i>
																<div class="flxRow hSpace05" style="background: white; width: fit-content; border: solid 2px; border-radius: 3px; padding: 2px 7px; align-items: center;"
																	 *ngIf="file.category"
																	 [ngStyle]="{'border-color': setInboundStatusStyles(file.status).color,
                                                                                    'color': setInboundStatusStyles(file.status).color}">
																	<i class="fa" style="color: inherit; font-size: 10px;" [ngClass]="setInboundStatusStyles(file.status).icon"></i>
																	<span style="color: inherit; font-size: 11px;">{{file.category}}</span>
																</div>
															</div>
														</div>
														<div class="flxRow" style="align-items: flex-end;">
                                                                    <span class="ellipsis" style="display: block; font-weight: 300; padding-right: 45px; flex: 1 0;" *ngIf="file.type">
                                                                        <b>Type</b>: {{file.type}}
                                                                    </span>
														</div>
														<div class="flxRow" style="align-items: flex-end;">
                                                                    <span class="ellipsis" style="display: block; font-weight: 300; padding-right: 45px; flex: 1 0;" *ngIf="file.hash">
                                                                        <b>Hash</b>: {{file.hash}}
                                                                    </span>
															<a *ngIf="file.hash" (click)="copyItemToClipboard(file.hash);" style="text-align: right;">
																<i class="far fa-copy" style="opacity: 0.7;" tooltip="Copy file hash"></i>
															</a>
														</div>
														<div class="flxRow" style="align-items: flex-end;" *ngIf="file.malware_type">
                                                                    <span class="ellipsis" style="display: block; font-weight: 300; padding-right: 45px; flex: 1 0;" >
                                                                        <b>Malware Type</b>: <span tooltip="{{file.malware_type}}">{{file.malware_type}}</span>
                                                                    </span>
															<a (click)="copyItemToClipboard(file.malware_type);" style="text-align: right;">
																<i class="far fa-copy" style="opacity: 0.7;" tooltip="Copy malware type"></i>
															</a>
														</div>
													</div>
												</td>
											</tr>
										</table>
									</div>
									<span *ngIf="!curTPResults.resHash.list || !curTPResults.resHash.list.length">No attachments in email</span>
								</div>
								<div class="flxClmn-center" style="align-items: center; flex: 1 0;" *ngIf="!curTPResults">
									<span style="opacity: 0.5;">Loading</span>
								</div>
							</div>
						</div>
						<div class="email-content-card ro15 co10 md-co24" style="position: relative; margin: 0.75vw; min-height: 755px; max-height: 75vh;" *ngIf="allowReviewerShowContent"
							 [ngClass]="{'is-showing-content' : curEmail?.isShowingContent || curEmail?.content?.html}">
							<div class="threat-protection-card flxClmn w100 h100" style="position: relative; z-index: 3; margin: 0;">
								<div class="card-header flxRow-between" style="align-items: center;">
                                            <span class="card-title">
                                                Email Content
                                            </span>
									<div class="flxRow hSpace1" [ngClass]="{'disabled' : !curEmail?.content?.html}">
										<a>
											<i class="far fa-solid fa-code" style="font-size: 1rem;" tooltip="View source"
											   (click)="showHtml = !showHtml"></i>
										</a>
										<a>
											<i class="far fa-download" tooltip="Download email as EML" style="font-size: 1rem;"
											   (click)="downloadEml(curEmail)"></i>
										</a>
									</div>
								</div>

								<div style="font-family: 'Roboto Condensed'; opacity: 0.8; align-items: center; letter-spacing: 0.4px; font-size: 0.75rem; background: #f6f6f6; padding: 10px 20px; border-top: none; border-bottom: solid 1px #d4d4d4; border-bottom-width: 3px;" class="flxRow hSpace1" *ngIf="!showHtml && curEmail?.content">
									<i style="opacity: 0.75;" class="far fa-exclamation-circle"></i>
									<span>NOTE: Email content is not fully displayed here since some elements are missing from this view, like CSS and JS.</span>
								</div>

								<div *ngIf="curEmail?.content"
									 class="input-wrap flxClmn" style="flex: 1 0; overflow: auto; padding: 15px 20px 10px; background: #f9f9f9;">
									<div *ngIf="!showHtml" style="flex: 1 0; flex-direction: column;" [ngStyle]="{'display': showHtml ? 'none' : 'flex'}">
										<div id="quarantinedHtmlContainer" class="static-color" style="flex: 1 0; overflow: auto; background: white; padding: 0 10px;" *ngIf="curEmail.content.html">
											<div id="quarantinedHtmlContainerData" style="display: inline; white-space: normal; margin: 0 0 0 1em;" [innerHTML]="curEmail.content.html"></div>
										</div>
										<div id="quarantinedAttachmentsContainer" *ngIf="curEmail.content.attachments.length">
											<hr style="width: 80%; margin: 10px auto;"/>
											<div class="flxRow hSpace1" style="margin: 0;">
												<div class="flxRow" style="flex:1 0; max-height: 66px; flex-wrap: wrap; overflow: auto;">
													<attachment-c
														*ngFor="let file of curEmail.content.attachments"
														[attName]="file.name"
														[attSize]="file.size"
														(preview)="previewAttachment = file;"
														(download)="downloadAttachment(file.content, file.name, file.type)">
													</attachment-c>
												</div>
											</div>
										</div>
									</div>

									<div *ngIf="showHtml" class="flxClmn" style="flex: 1 0;">
										<pre>{{curEmail.content.html || curEmail.content.text}}</pre>
									</div>
								</div>

								<!--"show content" button for large size-->
								<div class="flxClmn-center" style="align-items: center; flex: 1 0; background: radial-gradient(transparent, #f5f8ff);"
									 [ngClass]="curEmail.loadingEmailContent && 'shinyFX'"
									 [ngStyle]="{'overflow' : curEmail.loadingEmailContent ? 'hidden' : 'auto'}"
									 *ngIf="!curEmail.content">
									<btn-c class="show-email-large-btn"
										   [loading]="curEmail.loadingEmailContent"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.review.display)">
										Show Content
									</btn-c>
								</div>
							</div>

							<!--label "show content" button for laptop size-->
							<a class="hSpace1 blueLink flxRow-center show-email-medium-btn"
							   style="padding: 10px; font-size: 0.9rem; font-weight: 500; align-items: center; position: relative; z-index: 5;"
							   *ngIf="!curEmail.isShowingContent && !curEmail.content"
							   [ngClass]="{'disable': loadQuarantineData}"
							   (click)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.review.display)">
								<span>Show Email Content</span>
								<i class="far fa-chevron-down animated flash infinite" style="font-size: 0.6rem; margin-top: 0; animation-duration: 2.5s;"></i>
							</a>
						</div>
						<div class="threat-protection-card flxClmn ro15 co12 md-co24" style="min-height: min(400px,47vh);">
							<div class="card-header flxRow-between" style="align-items: center; height: 45px;">
                                        <span class="card-title">
                                            Headers
                                        </span>
								<!--Search-->
								<search-box [isDisabled]="!(curEmail?.headers?.length)"
											[(model)]="headerSearchTerm"
											(modelChange)="searchHeader();"
											placeholder="Search header">
								</search-box>
							</div>
							<!--headers table-->
							<div class="flxClmn" style=" flex: 1 0; overflow: auto;">
								<div class="flxClmn" style="flex: 1 0; padding: 0 15px 10px;" *ngIf="curEmail.headers && curEmail.headers.length">
									<table class="simpleDataTable w100 message-analysis-table middle" style="table-layout: fixed; white-space: pre-wrap; word-break: break-word;">
										<tr>
											<th style="width: 215px;"></th>
											<th></th>
										</tr>
										<tr *ngFor="let headerObj of curEmail.headers" [hidden]="headerObj.hide">
											<td><b>{{headerObj.name || headerObj.key}}</b></td>
											<td>
												<span>{{headerObj.value}}</span>
											</td>
										</tr>
									</table>
								</div>
								<div class="flxClmn-center" style="align-items: center; flex: 1 0; background: radial-gradient(transparent, #f5f8ff);"
									 *ngIf="!(curEmail.headers && curEmail.headers.length)"
									 [ngClass]="curEmail.loadingHeaders && 'shinyFX'"
									 [ngStyle]="{'overflow' : curEmail.loadingHeaders ? 'hidden' : 'auto'}">
									<btn-c style="z-index: 5;"
										   [loading]="curEmail.loadingHeaders"
										   (action)="selectAction(curEmail, dic.CONSTANTS.quarantinedActions.headers.display)">
										Get headers
									</btn-c>
								</div>
							</div>
						</div>
						<div class="threat-protection-card flxClmn ro15 co12 md-co24" style="min-height: 350px;">
							<div class="card-header d-flex flex-row" style="align-items: center; justify-content: space-between; height: 45px;">
                                    <span class="card-title">
                                        Reviewers Activity {{curEmail.reviewer_actions.length ? '(' + curEmail.reviewer_actions.length + ')' : ''}}
                                    </span>
								<!--Search-->
								<search-box [isDisabled]="!(curEmail?.reviewer_actions?.length)"
											[(model)]="reviewerSearchTerm"
											(modelChange)="searchReviewer();"
											placeholder="Find in results">
								</search-box>
							</div>
							<div class="flxClmn" style="flex: 1 0; align-items: center; padding: 15px; overflow: auto;"
								 [ngStyle]="{'justify-content' : !curEmail.reviewer_actions || !curEmail.reviewer_actions.length ? 'center' : ''}">
								<table style="text-align: left; width:100%; table-layout: fixed;" class="simpleDataTable" *ngIf="curEmail.reviewer_actions && curEmail.reviewer_actions.length">
									<tr>
										<th style="width: 20%;">Created</th>
										<th style="width: 25%;">Reviewer</th>
										<th style="width: 50%;">Action</th>
									</tr>
									<tr *ngFor="let actionObj of curEmail.reviewer_actions | orderBy: '-created'" [hidden]="actionObj.hide">
										<td >
											{{actionObj.created | date:'MM/dd/yyyy HH:mm'}}
										</td>
										<td style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
											{{actionObj.reviewer}}
										</td>
										<td style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden;">
											<span style="display: block; width: fit-content; max-width: 100%;" tooltip="{{actionObj.action}}">{{actionObj.action}}</span>
										</td>
									</tr>
								</table>
								<span style="opacity: 0.7;" *ngIf="!curEmail.reviewer_actions || !curEmail.reviewer_actions.length">
                                            No activity by reviewers
                                        </span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</popup-c>

	<!--Authenticate Sender popup-->
	<popup-c class="overflownV" *ngIf="showAuthSenderPopup"
			 head="Authenticate Sender" size="dynamic"
			 (closeCb)="showAuthSenderPopup = false;"
			 (confirmCb)="authenticateSender();"
			 [buttons]="{
                     cancel: blockSenderAuthRequest ? 'OK' : 'Cancel',
                     confirm: {text: 'Authenticate', disabled: authSenderInProcess || (senderAuthMethod === dic.CONSTANTS.authenticateSenderMethods.phone && !senderAuthPhone.phone_number),
                               loading: authSenderInProcess, hide: blockSenderAuthRequest}
                     }">
		<div class="flxClmn f-1-0" style="overflow: visible;">
			<div style="margin-bottom: 20px; font-size: 15px; line-height: 23px;"
				 *ngIf="curEmail.auth_sender && curEmail.auth_sender.updated"
				 [ngStyle]="!blockSenderAuthRequest && {'border-bottom': '1px solid #ccc'}">
				<div *ngIf="curEmail.auth_sender.method === dic.CONSTANTS.authenticateSenderMethods.phone">Your last sender authentication request was sent to: +{{curEmail.auth_sender.phone.country_code}}-{{curEmail.auth_sender.phone.phone_number}}</div>
				<div *ngIf="curEmail.auth_sender.method === dic.CONSTANTS.authenticateSenderMethods.email">Your last sender authentication request was sent to: {{curEmail.sender}}</div>
				<div *ngIf="curEmail.auth_sender.status">Sender has {{curEmail.auth_sender.status === 'request' ? 'not yet responded to' : curEmail.auth_sender.status === 'approve' ? 'approved': 'denied'}} the authentication request</div>
				<div *ngIf="blockSenderAuthRequest">You can send a new request in {{dic.CONSTANTS.authSenderTtl - curEmail.auth_sender.minutes}} minutes</div>
			</div>
			<div *ngIf="!blockSenderAuthRequest">
				<div style="font-size: 16px;">
					Are you sure you want to verify the sender's identity?
					<i class="far fa-question-circle" style="cursor: pointer; margin-right:3px;"
					   tooltip="Sender will be asked to review the content of the sent email and either confirm or deny sending this email"></i>
				</div>
				<div style="margin-left: 20px; line-height: 27px;">
					<div>Sender will receive a message to confirm their identity:</div>
					<div class="input-group">
						<label class="radio-container" for="senderAuthMethodSMS" style="margin-bottom: 0;">
							<input type="radio" id="senderAuthMethodSMS" name="senderAuthMethod"
								   value="phone"
								   [(ngModel)]="senderAuthMethod">
							<span class="checkmark" style="top: 5px;"></span>
							<span>Via <b>SMS</b> (preferred)</span>
						</label>

						<div class="flxRow" style="line-height: initial;" [ngClass]="{'disabled-overlay' : senderAuthMethod !== dic.CONSTANTS.authenticateSenderMethods.phone}">
							<country-code-select [(model)]="senderAuthPhone.country_code"></country-code-select>
							<input type="tel" id="phone" placeholder="Phone number"
								   style="width: 120px; padding-right: 20px; margin: 0; margin-left: 2px;"
								   [(ngModel)]="senderAuthPhone.phone_number"
								   [disabled]="senderAuthMethod !== dic.CONSTANTS.authenticateSenderMethods.phone"
								   pattern="/^[0-9]*$/"
								   maxlength="10"
								   name="newPhone">
						</div>

					</div>
					<label class="radio-container ellipsis" for="senderAuthMethodEmail" style="margin-bottom: 0;">
						<input type="radio" id="senderAuthMethodEmail" name="senderAuthMethod"
							   value="email" style="height: 0;"
							   [(ngModel)]="senderAuthMethod">
						<span class="checkmark" style="top: 5px;"></span>
						<span class="ellipsis">Via <b>Email</b> {{curEmail.sender}}</span>
					</label>
				</div>
			</div>
		</div>
	</popup-c>

	<!--Set Email Category popup-->
	<popup-c class="overflownV" *ngIf="setCategoryPopup?.show"
			 head="Set Email Category" size="small"
			 subTitle="Update the email's category"
			 (closeCb)="setCategoryPopup = null;"
			 (confirmCb)="setCategoryConfirm();"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: setCategoryInProcess}}">
		<div class="flxClmn vSpace3 f-1-0" style="overflow: visible;">
			<div class="flxRow" style="align-items: center;">
				<div style="flex-basis: 70px;">Category:</div>
				<app-dropdown-c style="width: 100px;" text="{{setCategoryPopup.newCategory}}">
					<li *ngFor="let category of dic.CONSTANTS.quarantinedCategories"
						(click)="setCategoryPopup.newCategory = category;"
						id="{{category}}">
						{{category}}
					</li>
				</app-dropdown-c>
			</div>
			<div class="flxRow">
				<div style="flex-basis: 70px; line-height: 30px;">Reason:</div>
				<input type="text"
					   style="width: 250px;"
					   maxlength="100"
					   placeholder="Reason (optional)"
					   [(ngModel)]="setCategoryPopup.reason" />
			</div>

			<div class="flxRow-start hSpace1" style="align-items: center;">
				<checkbox id="reportTrustifi"
						  tooltipTxt="Our dedicated security team review each report daily and takes necessary actions to adjust our security features accordingly.
                          			 <br/>Based on feedback, our team can adjust the AI, add malicious senders to the global blacklist, enhance our security metrics and more."
						  tooltipDirection="right"
						  [(model)]="setCategoryPopup.reportToTrustifi">
					Report to Trustifi
				</checkbox>
				<span style="font-family: 'Roboto Condensed', sans-serif; color: cadetblue;">Recommended</span>
			</div>

			<div class="flxRow-start hSpace1" style="align-items: center;" *ngIf="!['Safe', 'External'].includes(setCategoryPopup.newCategory)">
				<checkbox id="blocklistSenderIdentity"
						  tooltipTxt="The sender's identity will be added to the blocklist, ensuring no further messages are received."
						  tooltipDirection="right"
						  [(model)]="setCategoryPopup.blocklistSenderIdentity">
					Blocklist Sender Identity
				</checkbox>
				<span style="font-family: 'Roboto Condensed', sans-serif; color: darkred;">{{setCategoryPopup.email?.sender}}</span>
			</div>
		</div>
	</popup-c>

	<!--URL tracking popup-->
	<popup-c *ngIf="urlTrackingPopup?.show"
			 head="URL Click Tracking" size="medium"
			 subTitle="See how many times you clicked on the URL, and which location and device was used when clicking it"
			 (closeCb)="urlTrackingPopup = null;"
			 [buttons]="{cancel: 'OK'}">
		<div class="flxClmn vSpace3 f-1-0" style="overflow: auto;">
			<span class="ellipsis"><b>URL:</b> {{urlTrackingPopup.urlAddress}}</span>
			<trustifi-table-c
				class="trustifi-table" style="flex: 1 0; z-index: 5;"
				[list]="urlTrackingPopup?.clickInfo?.devices"
				[headers]="[
                            {text: 'Click Time', sortKey: 'created', width: '150px'},
                            {text: 'Device'},
                            {text: 'Location'},
                        ]"
				[cellsPrototype]="[
						{textKey: 'created', textType: 'dateAndTime'},
						{html: 'deviceCell'},
						{html: 'locationCell'},
					]"
				[scopeInstances]="[{openLocation: openLocation}]"
				[options]="{
						itemsNameSingular: 'click incident',
						defaultSortKey: '-created',
					}"
			>
				<ng-template #customCells let-item let-cellId="cellId">
					<!--action cells-->
					<div *ngIf="cellId === 'deviceCell'">
						<span tooltip="{{item.agent && item.agent.browser ? item.agent.browser.name + ' (' + item.agent.browser.version + '), ' + item.agent.os.name + ' (' + item.agent.os.version + ')' : (item.agent.raw.ua || 'N/A')}}">
                    <span *ngIf="item.agent && item.agent.browser" tooltip="{{item.agent.raw.ua}}">
                        {{item.agent.browser.name + ' (' + item.agent.browser.version + '), ' + item.agent.os.name + ' (' + item.agent.os.version + ')'}}
                    </span>
                    <span *ngIf="item.agent && item.agent.raw && !item.agent.browser">{{item.agent.raw.ua || 'N/A'}}</span>
                </span>
					</div>
					<div *ngIf="cellId === 'locationCell'">
						<span>
                    <span *ngIf="item.location && item.location">{{item.location.country}}{{item.location.city ? (', ' + item.location.city) : ''}}</span>
                    <img style="cursor: pointer;" *ngIf="item.location && item.location.ll" (click)="openLocation(item.location.ll)" tooltip="Open in Google Maps" class="googleMaps" src="data:image/png;base64,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" alt=""/>
                </span>
					</div>
					<div *ngIf="cellId === 'x'">
					</div>
				</ng-template>
			</trustifi-table-c>
		</div>
	</popup-c>

	<!--Blocklist sender-->
	<popup-c class="overflownV bs-enabled" *ngIf="blocklistSenderPopup?.show"
			 head="Add Sender to Blocklist" size="dynamic"
			 subTitle="Blocklisted emails will be automatically removed from the recipient's inbox"
			 (closeCb)="blocklistSenderPopup = null;"
			 (confirmCb)="blocklistSenderPopup.doneCb();"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: blocklistSenderPopup.applyInProcess}}">
		<div class="flxClmn vSpace3 f-1-0" style="overflow: visible;">
			<div class="d-flex gap-2 flex-column">
				<span>Choose specific items to add to blocklist:</span>
				<div class="d-flex flex-column gap-1">
					<div class="flxRow-start hSpace1 animated fadeIn" style="padding: 0; align-items: center;" *ngFor="let input of blocklistSenderPopup.items; let $index = index;">
						<checkbox id="allowListItem2{{$index}}" [(model)]="input.model">
							{{input.text}}
						</checkbox>
						<i class="far fa-exclamation" style="color: red; margin-left: 3px; font-size: 0.5rem; border: solid 1px red; border-radius: 50%; width: 14px; height: 14px; display: flex; justify-content: center; align-items: center;"
						   *ngIf="input.warning"
						   tooltip="{{input.warning}}"></i>
					</div>
				</div>
			</div>
			<div class="align-items-center flex-row gap-3">
				<div>Reason:</div>
				<input type="text" placeholder="(Optional)"
					   style="width:330px;" [required]="false"
					   [(ngModel)]="blocklistSenderPopup.blacklistReason"/>
			</div>
		</div>
	</popup-c>

	<!--Allowlist sender-->
	<popup-c class="overflownV bs-enabled" *ngIf="allowlistSenderPopup?.show"
			 head="Add Sender to Allowlist" size="dynamic"
			 subTitle="Allowlisted emails will be automatically released to the recipient's inbox"
			 (closeCb)="allowlistSenderPopup = null;"
			 (confirmCb)="allowlistSenderPopup.doneCb();"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Add', loading: this.allowlistSenderPopup.applyInProcess}}">
		<div class="flxClmn vSpace3 f-1-0" style="overflow: visible;">
			<div class="d-flex gap-2 flex-column">
				<span>Choose specific items to add to allowlist:</span>
				<div class="d-flex flex-column gap-1">
					<div class="flxRow-start hSpace1 animated fadeIn" style="padding: 0; align-items: center;" *ngFor="let input of allowlistSenderPopup.items; let $index=index;">
						<checkbox id="allowListItem{{$index}}" [(model)]="input.model">
							{{input.text}}
						</checkbox>
						<i class="far fa-exclamation" style="color: red; margin-left: 3px; font-size: 0.5rem; border: solid 1px red; border-radius: 50%; width: 14px; height: 14px; display: flex; justify-content: center; align-items: center;"
						   *ngIf="input.warning"
						   tooltip="{{input.warning}}"></i>
					</div>
				</div>
			</div>
			<div class="align-items-center flex-row gap-3">
				<div>Reason:</div>
				<input type="text" placeholder="(Optional)"
					   style="width:330px;" [required]="false"
					   [(ngModel)]="allowlistSenderPopup.whitelistReason"/>
			</div>
		</div>
	</popup-c>

	<!--Change notification options popup-->
	<popup-c class="overflownV" *ngIf="notifyOptionsPopup?.show"
			 head="Notification Options"
			 (closeCb)="notifyOptionsPopup = null"
			 (confirmCb)="changeNotifyPeriod()"
			 [buttons]="{confirm: {text: 'Confirm', loading: notifyOptionsPopup.changeNotifyPeriodInProcess}}"
			 size="dynamic">
		<div class="flxClmn vSpace2 f-1-0" style="overflow: visible; min-height: 130px;">
			<span>Select the notification timing on quarantined emails.</span>

			<div class="flxRow hSpace1" style="align-items: flex-start;">
				<span style="flex-basis: 170px; flex-shrink: 0; color: var(--ui-text-muted);">Currently:</span>
				<div class="flxClmn vSpace05" style="color: var(--ui-text-muted);">
					<span>{{notifyOptionsPopup.currentDisplay.periods}}</span>
					<span *ngIf="notifyOptionsPopup.currentDisplay.hasCustomTimes">Hours: {{notifyOptionsPopup.currentDisplay.hours}}</span>
					<span *ngIf="notifyOptionsPopup.currentDisplay.hasCustomTimes">Days: {{notifyOptionsPopup.currentDisplay.days}}</span>
				</div>
			</div>

			<div class="flxRow hSpace1" style="align-items: center; z-index: 50;">
				<span style="flex-basis: 160px; flex-shrink: 0;">Select notification timing:</span>
				<div style="flex: 1 0; position: relative;">
					<app-dropdown-c style="width: 300px; min-width: 100%;"
									[error]="notifyOptionsPopup.isNotifyReviewerPeriodsError"
									text="{{notifyOptionsPopup.periods && _.keys(_.pickBy(notifyOptionsPopup.periods)).join(', ').replace('Notify every day', 'Custom notification times') || 'Select'}}">
						<li *ngFor="let periodKey of dic.CONSTANTS.tpRule.notifyOptions | keyvalue: gs.returnZero"
							(click)="notifyOptionsPopup.periods[periodKey.value] = !notifyOptionsPopup.periods[periodKey.value]; notifyOptionsPopup.isNotifyReviewerPeriodsError = false; $event.stopPropagation();"
							id="{{'notifyReviewerPeriod_' + periodKey.key}}">
							<checkbox (click)="$event.preventDefault();"
									  [model]="notifyOptionsPopup.periods[periodKey.value]">
								{{periodKey.value === dic.CONSTANTS.tpRule.notifyOptions.everyDay ? 'Custom notification times' : periodKey.value}}
							</checkbox>
						</li>
					</app-dropdown-c>
					<span style="position: absolute; bottom: -20px; right: 0;  font-size: 12px; color: red;"
						  *ngIf="notifyOptionsPopup.isNotifyReviewerPeriodsError">
                            required field
					</span>
				</div>
			</div>
			<div class="flxRow hSpace1 animated fadeIn w100" style="align-items: center; margin-top: 10px; z-index: 40;" *ngIf="notifyOptionsPopup.periods[dic.CONSTANTS.tpRule.notifyOptions.everyDay]">
				<span style="flex-basis: 160px;">Select notification hours:</span>
				<div style="position: relative; flex: 1 0;">
					<app-dropdown-c class="limit-height" style="width: 300px; min-width: 100%;"
									[error]="notifyOptionsPopup.isNotifyReviewerDailyHoursError"
									text="{{gs.getDailyHoursText(notifyOptionsPopup.dailyHours) || 'Select'}}">
						<li *ngFor="let twoDigitHour of gs.hoursArr"
							(click)="toggleNotificationDailyHour(notifyOptionsPopup.dailyHours, twoDigitHour); $event.stopPropagation();"
							id="{{'notifyReviewerDailyHour_' + twoDigitHour}}">
							<checkbox (click)="$event.preventDefault();"
									  [model]="notifyOptionsPopup.dailyHours.includes(twoDigitHour)">
								{{twoDigitHour + ':00'}}
							</checkbox>
						</li>
					</app-dropdown-c>
					<span style="position: absolute; bottom: -17px; right: 0;  font-size: 12px; color: red;"
						  *ngIf="notifyOptionsPopup.isNotifyReviewerDailyHoursError">
						required field
					</span>
				</div>
			</div>
			<div class="flxRow hSpace1 animated fadeIn" style="align-items: center; margin-top: 10px; z-index: 39;" *ngIf="notifyOptionsPopup.periods[dic.CONSTANTS.tpRule.notifyOptions.everyDay]">
				<span style="flex-basis: 160px;">Select notification days:</span>
				<div style="position: relative; flex: 1 0;">
					<app-dropdown-c class="limit-height" style="width: 300px; min-width: 100%;"
									[error]="notifyOptionsPopup.isNotifyReviewerDaysError"
									[items]="notifyOptionsPopup.notifyReviewerDays"
									[isMultipleSelection]="true"
									[hideCounter]="true"
									itemDisplayKey="day">
					</app-dropdown-c>
					<span style="position: absolute; bottom: -17px; right: 0;  font-size: 12px; color: red;"
						  *ngIf="notifyOptionsPopup.isNotifyReviewerDaysError">
						required field
				</span>
				</div>
			</div>
		</div>
	</popup-c>

	<!--Release Request-->
	<popup-c class="bs-enabled" *ngIf="requestReleasePopup?.show"
			 head="Request release of quarantined email" size="dynamic"
			 (closeCb)="requestReleasePopup = null;"
			 (confirmCb)="requestReleaseExecute()"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', loading: requestReleasePopup.applyInProcess }}">
		<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
			<p>You are about to send a request to release this email from quarantine</p>

			<div class="align-items-center flex-row gap-3">
				<div>Release reason:</div>
				<input type="text"
					   style="width:330px;"
					   [(ngModel)]="requestReleasePopup.reason"/>
			</div>
		</div>
	</popup-c>

	<preview-link-c
		*ngIf="openPreviewLinkPopup?.show"
		(cancelCb)="previewLink(false)"
		[url]="openPreviewLinkPopup.url">
	</preview-link-c>

	<attachment-preview
		*ngIf="previewAttachment"
		[attachment]="previewAttachment"
		(onClose)="previewAttachment = null;">
	</attachment-preview>
</div>

